module.exports = __webpack_public_path__ + "img/horizontal_3_3_8004.fca82e04.png";